export const AVAILABLE_SERVICES = [
  {
    title: "Search",
    key: "search",
  },
  {
    title: "Reverse Geo",
    key: "reverse_geo",
  },
  {
    title: "Route",
    key: "route",
  },
];

export const OAUTH_CLIENT_ID = process.env.VUE_APP_GOOGLE_OAUTH_KEY;

export const CARTA_BASE_API_URL = process.env.VUE_APP_CARTA_BASE_API_URL;

export const CARTA_BILLING_BASE_URL =
  process.env.VUE_APP_CARTA_BILLING_BASE_URL;

export const CARTA_WEBSITE_URL = process.env.VUE_APP_CARTA_WEBSITE_URL;

export const LOCAL_STORAGE_KEY = "user";

export const MEMBER_STATUS = {
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
  DEACTIVE: "DEACTIVATE",
};

export const MEMBER_STATUS_DROPDOWN_OPTIONS = [
  {
    label: "Active",
    value: MEMBER_STATUS.ACTIVE,
  },
  {
    label: "Inactive",
    value: MEMBER_STATUS.DEACTIVE,
  },
  {
    label: "Pending",
    value: MEMBER_STATUS.PENDING,
  },
];

export const API_KEY_STATUS = {
  ACTIVE: "ACTIVE",
  DEACTIVE: "DEACTIVATE",
  MAXED_OUT: "MAXED OUT",
};

export const API_KEY_STATUS_CHANGE_REQUEST_TYPE = {
  ACTIVE: "ACTIVE",
  DEACTIVE: "DEACTIVATE",
};

export const API_KEY_STATUS_DROPDOWN_OPTIONS = [
  {
    label: "Active",
    value: API_KEY_STATUS.ACTIVE,
  },
  {
    label: "Inactive",
    value: API_KEY_STATUS.DEACTIVE,
  },
  {
    label: "Maxed Out",
    value: API_KEY_STATUS.MAXED_OUT,
  },
];

export const CSV_HEADER = "API Name,API Key, Limit, Created At, Created By";

export const DURATIONS = [
  {
    tooltip: "1 Week",
    value: "1w",
  },
  {
    tooltip: "2 Weeks",
    value: "2w",
  },
  {
    tooltip: "1 Month",
    value: "1mo",
  },
  {
    tooltip: "3 Months",
    value: "3mo",
  },
  {
    tooltip: "6 Months",
    value: "6mo",
  },
];

export const INVOICE_STATUS = {
  PENDING: "PENDING",
  OVERDUE: "OVERDUE",
  PAID: "PAID",
};

export const INVOICE_STATUS_OPTIONS = [
  { id: "all", name: "All" },
  { id: INVOICE_STATUS.PENDING, name: "Pending" },
  { id: INVOICE_STATUS.OVERDUE, name: "Overdue" },
  { id: INVOICE_STATUS.PAID, name: "Paid" },
];

export const DIGITAL_PAYMENT_STATUS = {
  ACCEPTED: "ACCEPTED",
  FAILED: "FAILED",
  CANCELLED: "CANCELLED",
};

export const SERVICE_TYPES = {
  GLOBAL: 1,
  AUTOCOMPLETE: 2,
  REVERSE_GEO: 3,
  DISTANCE: 4,
  ROUTE: 5,
};

export const PASSWORD_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}|[\]\\:;"'<>,.?/~`]).{8,}$/;

export const VALID_NAME_PATTERN = /^[a-zA-Z][\w\s-]{2,50}$/;
// eslint-disable-next-line
export const EMAIL_PATTERN = /^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

export const VALID_ADDRESS_PATTERN =
  // eslint-disable-next-line
  /^[^<>@#$%^&*()_+{}|\[\]\\:;"'<>,.?/~`]*([ ,:.#/][^<>@#$%^&*()_+{}|\[\]\\:;"'<>,.?/~`]*)*$/;

// eslint-disable-next-line
export const VALID_CONTACT_NUMBER_PATTERN = /^(\+8801|01)\d{9}$/;

export const SIGNUP_TYPE = {
  INVITATION: "invitation",
  SSO: "SSO",
  BASIC: "BASIC",
};

export const MD_WINDOW_SIZE = 768;

export const WHAT_DO_YOU_DO_OPTIONS = [
  "Developer/Engineer",
  "Product Manager",
  "Business Owner",
  "Data Analyst",
  "Other",
];

export const HOW_DID_YOU_HEAR_ABOUT_US_OPTIONS = [
  "Online Search",
  "Social Media",
  "Friend/Colleague",
  "Other",
];

export const COMPANY_SIZE_OPTIONS = [
  "Less than 50 employees",
  "51-200 employees",
  "201-500 employees",
  "501-1,000 employees",
  "More than 1,000 employees",
];

export const CHART_LEGEND_COLORS = [
  "#f87b52",
  "#788df4",
  "#22ce55",
  "#c48bf2",
  "#f478d0",
  "#5bda84",
  "#ffae55",
  "#3a84e8",
  "#f2527d",
  "#68d948",
  "#f4a78d",
  "#4cc5f8",
  "#a0f852",
];
